import { Drawer, Typography } from '@mui/material';
import React from 'react';
import { Player } from '../../types';
import { PoolPlayLeaderboard } from '../PoolPlayLeaderboard';
import { TournamentStaticLeaderboard } from '../TournamentStaticLeaderboard';

type PropTypes = {
  cutoff?: number;
  openBottomDrawer?: boolean;
  handlePoolLeaderboardUsernameClick: (profileId: string) => void;
  leaderboardDrawerWidth: number;
  profileId: string;
  tournamentTotalPlayers?: number;
  showClickTip?: boolean;
};

export const TournamentLeaderboardDrawer = ({
  cutoff,
  openBottomDrawer,
  handlePoolLeaderboardUsernameClick,
  leaderboardDrawerWidth,
  profileId,
  tournamentTotalPlayers,
  showClickTip,
}: PropTypes) => {
  return (
    <Drawer
      sx={{
        width: `${leaderboardDrawerWidth}px`,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: `${leaderboardDrawerWidth}px`,
          boxSizing: 'border-box',
          bgcolor: '#333333',
        },
      }}
      variant="permanent"
      anchor="right"
    >
      <Typography variant={'h4'} textAlign={'center'} letterSpacing={3}>
        LEADERBOARD
      </Typography>
      <Typography variant={'caption'} textAlign={'center'} letterSpacing={3}>
        {`Total Players: ${tournamentTotalPlayers}`}
      </Typography>
      {showClickTip ? (
        <Typography
          variant={'caption'}
          textAlign={'center'}
          color="warning.main"
          marginTop={1}
        >
          Click player to view their scores
        </Typography>
      ) : null}
      <TournamentStaticLeaderboard
        cutoff={cutoff}
        onUsernameClick={handlePoolLeaderboardUsernameClick}
        openBottomDrawer={openBottomDrawer}
        profileId={profileId}
      />
    </Drawer>
  );
};
